module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Squad/images/border-bottom.14af8bd4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Squad/images/border-bottom.png
// module id = 2740
// module chunks = 11